var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Delete Zone","button-type":"danger","button-text":"Delete","show":_vm.shouldShow},on:{"update:show":function($event){_vm.shouldShow=$event},"confirm":_vm.deleteMFC}},[_c('p',[_vm._v(" Are you sure you want to delete the zone, "),_c('strong',[_vm._v(_vm._s(_vm.zone.name))]),_vm._v("? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }